module.exports = __webpack_public_path__ + "img/page-task.4b4d7a30.svg";